import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { BrandingProvider } from "@/context/BrandingContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Courses from "@/pages/Courses";
import Sessions from "@/pages/Sessions";
import MyLearning from "@/pages/MyLearning";
import Attendance from "@/pages/Attendance";
import Compliance from "@/pages/Compliance";
import Certificates from "@/pages/Certificates";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Sales from "@/pages/Sales";
import Settings from "@/pages/Settings";
import Emails from "@/pages/Emails";
import Members from "@/pages/Members";
import Interests from "@/pages/Interests";
import Orders from "@/pages/Orders";
import OrderPaid from "@/pages/OrderPaid";
import Shop from "@/pages/Shop";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Basket from "@/pages/Basket";
import MemberSetPassword from "@/pages/MemberSetPassword";
import BasketSuccess from "@/pages/BasketSuccess";
import CourseAccess from "@/pages/CourseAccess";
import MemberPortal from "@/pages/MemberPortal";

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return null;
  return <Navigate to={user ? "/dashboard" : "/login"} replace />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrandingProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route path="/" element={<RootRedirect />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              {/* Public candidate-facing routes */}
              <Route path="/shop" element={<Shop />} />
              <Route path="/memberships" element={<Shop initialCat="Memberships" />} />
              <Route path="/members" element={<MemberPortal />} />
              <Route path="/members/set-password" element={<MemberSetPassword />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/basket" element={<Basket />} />
              <Route path="/basket/success" element={<BasketSuccess />} />
              <Route path="/order-paid/:token" element={<OrderPaid />} />
              <Route path="/access/:token" element={<CourseAccess />} />
              {/* Internal app */}
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/sessions" element={<Sessions />} />
                <Route path="/my-learning" element={<ProtectedRoute roles={["employee", "admin"]}><MyLearning /></ProtectedRoute>} />
                <Route path="/attendance" element={<ProtectedRoute roles={["trainer", "admin"]}><Attendance /></ProtectedRoute>} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/certificates" element={<Certificates />} />
                <Route path="/reports" element={<ProtectedRoute roles={["admin"]}><Reports /></ProtectedRoute>} />
                <Route path="/sales" element={<ProtectedRoute roles={["admin"]}><Sales /></ProtectedRoute>} />
                <Route path="/settings" element={<ProtectedRoute roles={["admin"]}><Settings /></ProtectedRoute>} />
                <Route path="/emails" element={<ProtectedRoute roles={["admin"]}><Emails /></ProtectedRoute>} />
                <Route path="/membership" element={<ProtectedRoute roles={["admin"]}><Members /></ProtectedRoute>} />
                <Route path="/interests" element={<ProtectedRoute roles={["admin"]}><Interests /></ProtectedRoute>} />
                <Route path="/orders" element={<ProtectedRoute roles={["admin"]}><Orders /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
        </BrandingProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
